// src/routes/protectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

// helper to check if token expired
function isTokenExpired(token) {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000; // exp is in seconds
  } catch {
    return true; // if decode fails, treat as expired
  }
}

const ProtectedRoute = ({ children, allowedRole }) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role");

  if (!token || isTokenExpired(token)) {
    localStorage.removeItem("token");
    return <Navigate to="/" replace />;
  }

  // If route doesn’t need protection → just return it
  if (!allowedRole) {
    return children;
  }

  // Protected route → check login
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Protected route → check role
  if (userRole !== allowedRole) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
